import { render, staticRenderFns } from "./FormsParceria.vue?vue&type=template&id=b05bb612&scoped=true"
import script from "./FormsParceria.vue?vue&type=script&lang=js"
export * from "./FormsParceria.vue?vue&type=script&lang=js"
import style0 from "./FormsParceria.vue?vue&type=style&index=0&id=b05bb612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05bb612",
  null
  
)

export default component.exports